let EquipmentLogView = require("../view/EquipmentLogView");

let SubjectEquipment = function (props) {
  let equipment = props.equipment;

  let debug = function (id, faults) {
    let out = function (obj) {
      return Object.keys(obj).map(function (key) {
        return key + ": " + (typeof obj[key] === "number" ? mc.format.datetime(obj[key]) : obj[key]);
      }).join("\n");
    };

    let component = (
      <div className="rc-subject-equipment-faults">
        <h1>{id}</h1>
        <pre>
          {faults.map((f) => out(f)).join("\n\n")}
        </pre>
      </div>
    );

    mc.ui.modal(component, { width: "600px" });
  };

  let history = function (id, type) {
    EquipmentLogView.open(id, type);
  };

  if (equipment) {
    if (equipment.length === 0) {
      return <div>{tx("none")}</div>;
    }

    return (
      <ul className="rc-subject-equipment">
        {equipment.map(function (device) {
          return (
            <li key={device.id} data-type={device.type} data-id={device.id} data-assigned={device.state === "ASSIGNED"}>
              <a onClick={history.bind(this, device.id, device.type)}>{device.id}</a>
              {device.faults.length > 0 && (
                <img
                  src="./img/rc/fault.svg"
                  width="16"
                  height="16"
                  data-tooltip={tx("equipment_fault")}
                  onClick={debug.bind(this, device.id, device.faults)}/>
              )}
            </li>
          );
        })}
      </ul>
    );    
  }

  return <div>{"..."}</div>;
};

module.exports = SubjectEquipment;
